/**
 * 全站公共事件。STATSIG.COMMON.VIEW → PAGE_VIEW
 *
 * 正在用：页面访问统一 PAGE_VIEW。
 * 已不算：业务交互伪装成 PAGE_VIEW；FAQ/条款等纯展示页若暂不关心可不打。
 *
 * value 与 metadata.page 相同，一律小写下划线。
 */
export enum CommonEvent {
    /**
     * 打开页面。
     * value 与 metadata.page 相同，见 PAGE
     */
    VIEW = 'PAGE_VIEW',
}

/**
 * PAGE_VIEW 的 page 名。菜单 / 产品面明文转小写下划线。
 */
export const PAGE = {
    /** /services/preapp — 开贷意向 / 贷款初始化 */
    PREAPP: 'loan_initialization',
    /** /services/preapp/emailverification — Save your progress */
    PREAPP_EMAIL_VERIFICATION: 'save_your_progress',
    /** /services/signin */
    LOGIN: 'login',
    /** /services/signup */
    SIGNUP: 'signup',
    /** /services/agentborrowersignup */
    AGENT_BORROWER_SIGNUP: 'agent_borrower_signup',
    /** /application/myloans — 我的贷款列表 */
    LOANS: 'loans',
    /** /application/v2/interview/* — 单笔贷款工作台（对齐 LOS PAGE.LOAN） */
    LOAN: 'loan',
    /** /application/credit-report-payment/:id — 征信报告付费 */
    CREDIT_REPORT_PAYMENT: 'credit_report_payment',
} as const

export type PageName = (typeof PAGE)[keyof typeof PAGE]
